import { render, staticRenderFns } from "./PwaRoleSelect.vue?vue&type=template&id=20b5e664&scoped=true&"
import script from "./PwaRoleSelect.vue?vue&type=script&lang=js&"
export * from "./PwaRoleSelect.vue?vue&type=script&lang=js&"
import style0 from "./PwaRoleSelect.vue?vue&type=style&index=0&id=20b5e664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b5e664",
  null
  
)

export default component.exports